import {
    IDV_POSITIONS,
    IdvPosition,
} from '@common/react/idv/useBaseIdvPosition';
import { OnboardingData } from '@common/types';

type IdvStepsParams = {
    currentView: IdvPosition;
    onboardingData?: OnboardingData;
};

type IdvStepsFilter = {
    hide: boolean;
    steps: IdvPosition[];
};

export const getIdvSteps = ({
    currentView,
    onboardingData,
}: IdvStepsParams): IdvPosition[] => {
    const getSteps = (filter: IdvStepsFilter[]) => {
        return IDV_POSITIONS.filter(
            (key) =>
                key === currentView ||
                !filter.find(({ hide, steps }) => steps.includes(key) && hide)
        );
    };
    const notEmployed =
        !!onboardingData?.employmentStatus &&
        onboardingData?.employmentStatus !== 'EMPLOYED';

    return getSteps([{ hide: notEmployed, steps: ['employer-address'] }]);
};

export const getNextPosition = ({
    currentView,
    ...params
}: IdvStepsParams): IdvPosition => {
    const steps = getIdvSteps({ currentView, ...params });
    const next = steps.indexOf(currentView) + 1;
    return steps[next];
};

export const getPrevPosition = ({
    currentView,
    ...params
}: IdvStepsParams): IdvPosition => {
    const steps = getIdvSteps({ currentView, ...params });
    const prev = steps.indexOf(currentView) - 1;
    return steps[prev] ?? steps.at(0);
};
